import styled from "styled-components";
import { Color, Font, breakpoints } from "@/shared/Constants";
import {
  onexoneWH,
  onexoneTitle,
  onexoneVolanta,
  onexonePicture,
  onexoneVideo,
  onexoneData,
  onexoneBoxTtile,
} from "../mixins-modules";

export const ContentOnexOneRecipe = styled.div`
  min-height: 480px;
  max-width: 300px;
  ${breakpoints.phone} {
    min-height: auto;
    max-width: 100%;
    min-width: 100%;
  }
  text-align: center;
  perspective: 1000px;
  .onexonerecipe{
    text-align: center !important;
  }
  .contentVideo {
    aspect-ratio: 16/9;
  }
  .mt {
    margin-top: 15px;
    ${onexoneBoxTtile}
    text-align: center;
    align-items: center;
    justify-content: center;
    ${(props) => props.mamsEnabled && "margin-top:35px"};
    ${breakpoints.phone} {
      padding: 0 14px;
      margin: 14px 0 48px;
    }
    h2.title {
      ${onexoneTitle}
      /* min-height: 90px; */
      text-align: center;
      margin: auto;
      font-size: 25px;
      line-height: 28px;
      ${Font.clarinVarSub2Regular}
        &.shortenTitle {
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        /* min-height: 75px; */
        ${breakpoints.phone} {
          min-height: auto;
          -webkit-line-clamp: inherit;
          font-size: 25px;
          line-height: 28px;
        }
      }
    }
    
   
    .volanta {
      //${onexoneVolanta}
      //${(props) => props.mamsEnabled && "display:none"}
      display: none !important;
    }
    // .bajada,
    .date {
      display: none;
    }
    .data-txt {
      ${onexoneData}
      margin-top: 5px;
      width: 100%;
      justify-content: center;
      & > p.name {
        ${Font.sansRegular}
        font-size: 11px;
        color: ${Color.grey};
        margin-top: 8px;
        text-align: center;
      }
    }
  }
  .mt .bottomSummary {
    display: none;
  }
  picture {
    ${onexonePicture}
    min-height: 300px;
    max-height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      height: 102%;
    }
  }
  .contentVideo {
    height: 148px;
    ${breakpoints.phone} {
      height: auto;
    }
  }

  .linkAbsolute {
    content: "";
    inset: 0;
    display: block;
    margin: 0px;
    padding: 0px;
    position: absolute;
    z-index: 3;
  }
  .food-card {
    z-index: 5;
  }
  a {
    width: 100%;
  }

  .flip-card-container-${(props) => props.id} {
    width: 100%;
    height: 100%;
    position: relative;
    transition: transform 0.8s;
    transform-style: preserve-3d;
  }

  .flip-card-container-${(props) => props.id}:has(#add-recipe-${(props) =>
      props.id}:checked) {
    transform: rotateY(180deg);
  }

  .flip-card-inner {
    ${onexoneWH}
    width:100%;
    height: 100%;
    position: relative;   
  }
`;
